import React, {useEffect, useState} from 'react';
import {CustomDivider, StyledPopUp} from "../../../../../shared";
import { StorageAndDeliveryConditionPopUpProps} from "../../../models";
import {Button, Divider, Flex, List} from "antd";
import StorageAndDeliveryConditionPopUpCard from "./StorageAndDeliveryConditionPopUpCard";

const StorageAndDeliveryConditionPopUp = ({open, onCansel,product}: StorageAndDeliveryConditionPopUpProps) => {
    const [data, setData] = useState<any[]>([])
    useEffect(() => {
        setData(product?.productConditions)
    }, [product]);
    const onActive = (id: number) => {
        setData(data.map((item: any) => ({
            ...item,
            isActive: id === item.id
        })))
    }
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);
    useEffect(() => {
        const handleResize = () => {
            setScreenHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return (
        <StyledPopUp
            open={open}
            title={
            <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "18px", fontWeight: 600 }}> شرایط نگهداری و تحویل محصول </span>

                <div
                style={{
                    backgroundColor: "#fff5f5",
                    border: "1px solid #ffcccc",
                    borderRadius: "8px",
                    padding: "8px 12px",
                    marginTop: "6px",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "8px",
                }}
                >
                <span style={{ fontSize: "18px" }}>⚠️</span>
                <span style={{ fontSize: "12px", color: "#cc0000", lineHeight: "1.6" }}>
                    لطفاً پیش از نهایی‌کردن اجاره، شرایط مربوط به <b>نگهداری</b> و <b>تحویل محصول</b> را با دقت مطالعه کنید.
                    این شرایط بخشی از مفاد <b>قرارداد اجاره</b> هستند و رعایت آن‌ها برای هر دو طرف الزامی است.
                </span>
                </div>
            </div>
            }
            onCancel={onCansel}
            width={"100%"}
            footer={null}
            transitionName={''}
        >
            <Flex vertical gap={"small"} style={{maxHeight: `${screenHeight-145}px`, overflowX: "hidden" ,overflowY: "auto"}}>
                <List
                    grid={{
                        gutter: 16,
                        xs: 1,
                        sm: 1,
                        md: 1,
                        lg: 1,
                        xl: 1,
                        xxl: 1,
                    }}
                    dataSource={data}
                    renderItem={(i) => (
                        <List.Item>
                            <Divider  orientation={"right"}> {i?.title}</Divider>
                            <List
                                grid={{
                                    gutter: 16,
                                    xs: 1,
                                    sm: 1,
                                    md: 1,
                                    lg: 1,
                                    xl: 1,
                                    xxl: 1,
                                }}
                                dataSource={i?.detail}
                                renderItem={(item:any) => (
                                    <List.Item>
                                        <StorageAndDeliveryConditionPopUpCard title={item.title} description={item.description}
                                        />
                                        <CustomDivider/>
                                    </List.Item>
                                )}
                            />
                        </List.Item>
                    )}
                />
                <Button type={"primary"} block size={"large"} onClick={onCansel}>متوجه شدم</Button>
            </Flex>
        </StyledPopUp>
    );
};

export default StorageAndDeliveryConditionPopUp;
